export default __webpack_public_path__ + "static/media/axelar-logo-horizontal-white.8f36f7bd.svg";